import React from "react";
import { Circle, Path, Svg } from "react-native-svg";

export interface BackArrowBadgeIconProps {
  size?: number;
  bgColor?: string;
  arrowColor?: string;
}

export const BackArrowBadgeIcon: React.FC<BackArrowBadgeIconProps> = ({
  size = 48,
  bgColor = "#fff",
  arrowColor = "#000",
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    // box-shadow: 0px 0px 25px 0px #40404040 (elevation is Android's nearest
    // equivalent — its shadow model doesn't take a blur radius directly).
    style={{
      borderRadius: size / 2,
      shadowColor: "#404040",
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.25,
      shadowRadius: 25,
      elevation: 12,
    }}
  >
    <Circle cx={24} cy={24} r={24} fill={bgColor} />
    <Path
      fill={arrowColor}
      d="m27.548 18.578-1.061-1.06-5.779 5.777a.995.995 0 0 0 0 1.413l5.779 5.78 1.06-1.06-5.424-5.425 5.425-5.425Z"
    />
  </Svg>
);

export default BackArrowBadgeIcon;
